import type { DropdownOption } from './types';
import type { Option } from '@usealloy/component-library';

export const logicOperatorOptions: DropdownOption[] = [
  { value: 'and', label: 'and' },
  { value: 'or', label: 'or' },
];

export const operatorOptions: DropdownOption[] = [
  {
    label: '*',
    value: '*',
    meta: {
      category: 'operator',
    },
  },
  {
    label: '/',
    value: '/',
    meta: {
      category: 'operator',
    },
  },
  {
    label: '+',
    value: '+',
    meta: {
      category: 'operator',
    },
  },
  {
    label: '-',
    value: '-',
    meta: {
      category: 'operator',
    },
  },
];

export const groupingOptions: Record<string, DropdownOption> = {
  open: {
    label: 'Open Group (',
    value: '(',
    meta: {
      category: 'grouping',
    },
  },
  close: {
    label: 'Close Group )',
    value: ')',
    meta: {
      category: 'grouping',
    },
  },
  ungroup: {
    label: 'Ungroup this',
    value: 'ungroup',
    meta: {
      category: 'grouping',
    },
  },
  cancel: {
    label: 'Cancel opening this group',
    value: 'cancel_pending_group',
    meta: {
      category: 'grouping',
    },
  },
  start: {
    label: '(',
    value: '(',
    meta: {
      category: 'grouping',
    },
  },
  end: {
    label: ')',
    value: ')',
    meta: {
      category: 'grouping',
    },
  },
};

export const dynamicComparisonOptions: Record<string, Option> = {
  toDynamic: {
    label: 'Switch to dynamic comparison',
    value: 'switch_rightside_to_dynamic',
  },
  toStatic: {
    label: 'Switch to static comparison',
    value: 'switch_rightside_to_static',
  },
};

export const reasonCodeGroupOption = {
  label: 'Configure Reason Code Groups',
  value: 'configure_reason_code_groups',
  ctaElementProps: {
    style: {
      color: 'var(--cl-juicyBlue-600)',
    },
  },
};

export const noReasonCodeGroupOption: DropdownOption = {
  label: 'No Reason Code Groups have been configured.',
  value: '',
};

export const flagSetOptions: DropdownOption[] = [
  { label: 'is set', value: 'true' },
  { label: 'is not set', value: 'false' },
];

export const booleanOptions: DropdownOption[] = [
  { label: 'is true', value: 'true' },
  { label: 'is false', value: 'false' },
];

export const editListOption: DropdownOption = {
  label: 'edit list...',
  value: '',
};

export const failureHandlingDescriptionFullThresholdMode = "This workflow will fall to this Service Failure Handling option if any part of any of its node's threshold logic is undefined.";
export const failureHandlingDescriptionBestEffortMode = 'This workflow will attempt to safely evaluate the threshold logic of each of its nodes to true or false, even if some parts of the threshold logic are undefined. If this is not possible, it will fall to this Service Failure Handling option.';
